import React from 'react';
import { getLabel } from '../../../data/labels';
import BetInfo from '../BetInfo';
import EventsList from '../EventsList';
import { getConfiguration } from '../../utils/configuration';
import { getTicketStatusDescription } from '../../utils/getTicketStatusDescription';

function MultipleBetsTicket(props) {
    let descTicket = getLabel('mybets.multipla');
    const isBetBuilder = props.ticket.betBuilderTotalOdd > 0;
    const conf = getConfiguration();
    let ticketStatus = null;
    if(props.infoTicket || conf.dtsch){
        descTicket = descTicket + " " + (props.ticket.psv? getLabel('retail.protocol.psv') : getLabel('retail.protocol.psqf'));
        ticketStatus = getTicketStatusDescription(props.ticket.status, props.ticket.paidWithCashout);
    }
    let typeOfBetBuilder = null;
    if(isBetBuilder){
    	descTicket = descTicket + ' ' + getLabel('betbuilder.betslip_title');
    	typeOfBetBuilder = props.ticket.betBuilderTotalOdd > 100? "ESTERO" : "ITALIA";
    }
    
    return (
        <div className="mybet-container d-flex flex-column">
            <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle">
                <span className="text-big">{descTicket} {'(' + props.ticket.events.length + ')'}</span>
                <span className="margin-auto">
                    {props.ticket.funBonus &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.funbonus')}</span>
                    }
                    {props.ticket.freeBet &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.freebet')}</span>
                    }
                    {ticketStatus &&
                        <span className="cg-mybet-status-label">{ticketStatus.toUpperCase()}</span>
                    }
                </span>
            </div>
            <hr />
            <div className="mybet-events-container">
                <EventsList isPsv={props.ticket.psv} events={props.ticket.events} isBetBuilder={isBetBuilder} typeOfBetBuilder={typeOfBetBuilder} />
            </div>
            <div className="light-grey-bg">
                <BetInfo isCheckbet={true} ticket={props.ticket} isBetBuilder={isBetBuilder} typeOfBetBuilder={typeOfBetBuilder} obfuscateTicketId={props.obfuscateTicketId} />
            </div>
        </div>
    );
}

export default MultipleBetsTicket;